(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["unfocussed-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.uf-home img[data-uf-story-image]';
    const loadImage = (image) => {
      image.loading = 'eager';
      if (image.dataset.srcset) image.srcset = image.dataset.srcset;
      if (image.dataset.src) image.src = image.dataset.src;
      image.removeAttribute('data-srcset');
      image.removeAttribute('data-src');
      image.removeAttribute('data-uf-story-image');
    };
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        loadImage(entry.target);
      });
    }, { rootMargin: '200px' }) : null;
    const initialize = (root) => {
      root.querySelectorAll(selector).forEach((image) => {
        if (observer) observer.observe(image);
        else loadImage(image);
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    } else {
      initialize(document);
    }
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      if (observer) event.target.querySelectorAll(selector).forEach((image) => observer.unobserve(image));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
